import React from "react";
import Image from "next/image";
import Head from "next/head";

//internal import
import Layout from "@layout/Layout";
import { contactData } from "@utils/data";
import { notifySuccess } from "@utils/toast";
import InputArea from "@component/form/InputArea";
import PageHeader from "@component/header/PageHeader";
// import axios from "axios";

const ContactUs = () => { 

  return <>
    <Layout title="Contact Us" description="This is contact us page">
      <Head>
        <meta property="og:title" content="Contact us - CubeNation" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.cubenationshop.com/contact-us" />
        <meta property="og:image" content="/facebook-page.png" />
        <meta
          property="og:description"
          content="CubeNation is one of the largest Speed cube shops in BD. It's simply a Puzzle Bazaar & cube collection store!"
        />
      </Head>
      <PageHeader title="Contact Us" />

      <div className="bg-white">
        <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
          {/* contact promo */}
          <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-3 xl:gap-8 font-serif">
            {contactData.map((data) => (
              <div
                key={data.id}
                className="border p-10 rounded-lg text-center"
              >
                <span className="flex justify-center text-4xl text-emerald-500 mb-4">
                  <data.icon />
                </span>
                <h5 className="text-xl mb-2 font-bold">{data.title}</h5>
                <p className="mb-0 text-base opacity-90 leading-7">
                  <a
                    href={`${data.type}:${data.contact}`}
                    className="text-emerald-500"
                  >
                    {data.contact}
                  </a>{" "}
                  {data.info}
                </p>
              </div>
            ))}
          </div>

          {/* contact form */}
          <div className="px-0 pt-24 mx-auto items-center flex flex-col md:flex-row w-full justify-between">
            <div className="hidden md:w-full lg:w-5/12 lg:flex flex-col h-full">
              <Image
                width={874}
                height={874}
                src="/contact-us.png"
                alt="logo"
                className="block w-auto"
                placeholder="blur"
                blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                style={{
                  maxWidth: "100%",
                  height: "auto"
                }} />
            </div>
            <div className="px-0 pb-2 lg:w-5/12 flex flex-col md:flex-row">
              <div className="w-full mx-auto flex flex-col justify-center"
              >
                <div className="mb-12">
                  <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold font-serif mb-3">
                    For any support just send your query
                  </h3>
                  <p className="text-base opacity-90 leading-7">
                    We will get back to you as soon as possible.
                  </p>
                </div>
                <button                        
                      onClick={() => {
                        if (window.$chatwoot) {
                          window.$chatwoot.toggle();
                        }
                      }}
                      className="md:text-sm leading-4 inline-flex items-center cursor-pointer transition ease-in-out duration-300 font-semibold text-center justify-center border-0 border-transparent rounded-md placeholder-white focus-visible:outline-none focus:outline-none bg-emerald-500 text-white px-5 md:px-6 lg:px-8 py-3 md:py-3.5 lg:py-3 hover:text-white hover:bg-emerald-1000 h-12 mt-1 text-sm lg:text-base w-full sm:w-auto"
                    >
                      Send Message
                    </button>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </>;
};

export default ContactUs;
